module.exports = __webpack_public_path__ + "img/16_newModelWorker_xzk.c4862ebc.png";